import React, { ChangeEvent, ReactElement, useEffect, useRef, useState } from 'react'
import { APIDeleteTemplate, APIGetAllTemplates, APITemplateResponse } from '../../services/APITemplateService';
import { dataMap } from '../createWarningComp/EWTemplate';
import { getSeverityColor } from '../createWarningComp/CommonMethods';
import { useTheme } from '../../context/ThemeContext';
import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useLocation, useNavigate } from 'react-router-dom';
import { PoliceTypes, UserData } from '../createWarningComp/CreateWarning';
import ToggleSwitch from '../toggleSwitchComp/ToggleSwitch';
import { APICallGetWarningTypeRequest, APIWarningTypeResponseType } from '../../services/APIEarlyWarningService';
import { earlyWarningTypes } from '../createWarningComp/FixedDataSet';
import { DeleteCardIcon, EditCardIcon, SearchIcon } from '../iconSet/IconSet';
import AlertDialog from '../popupComp/AlertDialog';
import { useUserData } from '../../context/UserDataContext';

type DashboardTemplatePropTypes = {
    gridArea?: string;
    title?: string;
}

const DashboardTemplate = (props: DashboardTemplatePropTypes) => {

    const { theme } = useTheme();
    const navigate = useNavigate()
    const { username, hasPolicy, loading, hasAllPolices } = useUserData()

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (title: string, description: string, yesCallback?: () => void, okCallback?: () => void ) => {
        setAlertTitle(title);
        setAlertDescription(description);
        setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
        setAlertOkCallback(() => okCallback);   // Will trigger only on OK
        setAlertDialogState(true);
    }
    

    const [userPolices, setUserPolices] = useState<PoliceTypes>({ simple: false, advanced: false, defaultSimple: false, defaultAdvanced: false})
    const [selectedTemplate, setSelectedTemplate] = useState<APITemplateResponse | null>(null)
    const [warningTypes, setWarningTypes] = useState<APIWarningTypeResponseType[]>([]);

    const [selectedType, setSelectedType] = useState<APIWarningTypeResponseType>()
    const [selectedPage, setSelectedPage] = useState<"SELECT" | "FORM">('SELECT')

    const [filterTemplateData, setFilterTemplateData] = useState<APITemplateResponse[]>([])

    const userIdRef = useRef<string>();
    
    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(false)

    // Template data
    const [templateData, setTemplateDate] = useState<APITemplateResponse[]>([])

    useEffect(() => {
        const getAllTemplates = async () => {
            setIsLoading(true)
            const response = await APIGetAllTemplates()

            if (response.status)
            {
                setTemplateDate(response.data)
                setFilterTemplateData(response.data)
            }
            else 
            {
                console.log("Data fetching error")
            }
            setIsLoading(false)
        }
        getAllTemplates()
    }, [])

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // const savedUser = sessionStorage.getItem("user");
                // if (!savedUser) {
                //     throw new Error("No user in sessionStorage");
                // }

                // const parsedUser = JSON.parse(savedUser);
                // const userId = parsedUser.userId;
                userIdRef.current = username

                const result = await APICallGetWarningTypeRequest(username);
                setWarningTypes(result); // set response to state if needed
                //console.log(">>>>>>>>> result:", result)
            } catch (error) {
                console.error("Initialization error:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchInitialData();
    }, [loading])

    const handleClickTemplate = (item: APITemplateResponse) => {
        const data = item;
        const params = new URLSearchParams({data: JSON.stringify(data)}).toString();
        navigate(`/early_warning/trigger_template?${params}`)
    }

    // useEffect(() => {
    //     const userDataString = sessionStorage.getItem("userdetails")
    //     if (userDataString) {
    //         const userData: UserData = JSON.parse(userDataString)
    //         const policiesList: string[] = userData.policies.split(',').map(policy => policy.trim())
    
    //         setUserPolices({
    //             simple: policiesList.includes("Simple Early Warning Trigger"),
    //             advanced: policiesList.includes("Advance Early Warning Trigger"),
    //             defaultSimple: policiesList.includes("Both Early Warning Trigger - Simple"),
    //             defaultAdvanced: policiesList.includes("Both Early Warning Trigger - Advance"),
    //         })

            
    //     } else {
    //         setUserPolices({ simple: false, advanced: false, defaultSimple: false, defaultAdvanced: false })
    //     }
    // }, [])

    const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false)
    useEffect(() => {
        if (isDataLoaded) return
        setUserPolices({
            simple: hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER"),
            advanced: hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER"),
            defaultSimple: hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"),
            defaultAdvanced: hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED"),
        })
        if (username !== null || username !== ""){
            setIsDataLoaded(true)
        }
    }, [])

    const [toggle, setToggle] = useState<boolean>(false)
    // useEffect(() => {
    //     if (userPolices)
    //     {
    //         if (userPolices.simple && !userPolices.advanced) 
    //         {
    //             setToggle(false)
    //         }
    //         else if (!userPolices.simple && userPolices.advanced)
    //         {
    //             setToggle(true)
    //         }

    //         if (userPolices.defaultAdvanced && !userPolices.defaultSimple)
    //         {
    //             setToggle(true)
    //         }
    //         else if (!userPolices.defaultAdvanced && userPolices.defaultSimple)
    //         {
    //             setToggle(false)
    //         }
    //     }
    // }, [userPolices])

    useEffect(() => {
        if (hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && !hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER")) 
            {
                setToggle(false)
            }
            else if (!hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER"))
            {
                setToggle(true)
            }

            if (hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && !hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(true)
            }
            else if (!hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(false)
            }
    }, [hasPolicy])

    const handleEWTypeClick = (ewType: APIWarningTypeResponseType) => {
        const data = ewType;
        const params = new URLSearchParams({data: JSON.stringify(data)}).toString();
        navigate(`/early_warning/generate_warning?${params}`)
    }

    const findIcon = (wType: string): ReactElement<any, any> | null => {
        const match = earlyWarningTypes.find(item => item.wType === wType);
        return match?.icon ?? null;
    }

    // Handle edit template
    const handleEditTemplateClick = (id: string) => {
        const url = `/early_warning/setup_template?id=${id}`
        navigate(url)
        console.log("Edit template ->", id)
    }


    // Handle delete template
    const handleDeleteTemplateClick = async (id: string) => {
        setIsLoading(true)
        const response = await APIDeleteTemplate(id)

        if (response.status)
        {
            showAlertDialog("Success", "✅ Warning template deleted successfully!", undefined, () => window.location.reload());
        }
        else 
        {
            showAlertDialog("Error", `❌ ${response.message}`)
        }
        setIsLoading(false)
    }

    // Handle search change
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        if (value === "" || value === null || value === undefined)
        {
            setFilterTemplateData(templateData)
        }
        else 
        {
            setFilterTemplateData(prevState => (
                templateData.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
            ))
        }
    }

    return (
        <>
           {warningTypes.length > 0 && (
            <div className='dashboard-templates' style={{gridArea: props.gridArea ? props.gridArea : ''}}>
                {templateData.length > 0 || warningTypes.length > 0 ? (
                    <div className='title'>
                        {/* {!selectedTemplate ? (<span>Select warning {toggle ? 'type' : 'template'}</span>) : (<span>setup {selectedTemplate.name} (Template)</span>)} */}
                        <span>Generate Early Warning</span>
                        {/* {!selectedTemplate && (
                            userPolices.simple && userPolices.advanced && (
                                <div className='switch-wrapper'>
                                    <ToggleSwitch switchState={toggle} setSwitchState={setToggle} width={2} leftLabel='Simple' rightLabel='Advanced' backgroundColor='var(--color-data-wrapper-bg)' switchColor='var(--color-accent)'/>
                                </div>
                            )
                        )} */}
                        
                    </div>
                ) : (
                    <div className='title'>
                        <span>Generate Early Warning</span>
                    </div>
                )}
                
                {toggle && (
                    <div className="body-1-wrapper">
                        {!selectedTemplate && (
                            (hasAllPolices(["SIMPLE_EARLY_WARNING_TRIGGER", "SIMPLE_EARLY_WARNING_TRIGGER"])) && (
                                <div className="tab-wrapper">
                                    <div className="tab-button" style={{borderRadius: '0 0.5rem 0 0', backgroundColor: !toggle ? "var(--color-email-side-menu-bg)" : "transparent", borderWidth: toggle ? "0 0 0.2rem 0" : "0.2rem"}} onClick={(e) => setToggle(false)}>
                                        <span>Template-Based</span>
                                    </div>
                                    <div className="tab-button" style={{borderRadius: '0.5rem 0 0 0', borderWidth: !toggle ? "0 0 0.2rem 0" : "0.2rem", backgroundColor: toggle ? "var(--color-email-side-menu-bg)" : "transparent",}} onClick={(e) => setToggle(true)}>
                                        <span>Customized</span>
                                    </div>
                                </div>
                            )
                        )}
                        <div className='body-1'>
                            {warningTypes.length > 0 ? (
                                <div className='type-selector-wrapper-container'>
                                    {warningTypes.map((ewType, index) => (
                                        <div key={index} className='ew-item' onClick={(e) => handleEWTypeClick(ewType)} style={{backgroundColor: selectedType?.warningId === ewType.warningId ? 'var(--color-card-select-bg)' : 'var(--color-card-bg)'}}>
                                            {findIcon(ewType.hazardType)}
                                            <span>{ewType.warningName}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className='type-selector-wrapper-container-empty'>
                                    <span>No any warning types available for you</span>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    
                )}
                {!toggle && (
                    <div className="body-wrapper">
                        {!selectedTemplate && (
                            (hasAllPolices(["SIMPLE_EARLY_WARNING_TRIGGER", "SIMPLE_EARLY_WARNING_TRIGGER"])) && (
                                <div className="tab-wrapper">
                                    <div className="tab-button" style={{borderRadius: '0 0.5rem 0 0', backgroundColor: !toggle ? "var(--color-email-side-menu-bg)" : "transparent", borderWidth: toggle ? "0 0 0.2rem 0" : "0.2rem"}} onClick={(e) => setToggle(false)}>
                                        <span>Template-Based</span>
                                    </div>
                                    <div className="tab-button" style={{borderRadius: '0.5rem 0 0 0', borderWidth: !toggle ? "0 0 0.2rem 0" : "0.2rem", backgroundColor: toggle ? "var(--color-email-side-menu-bg)" : "transparent",}} onClick={(e) => setToggle(true)}>
                                        <span>Customized</span>
                                    </div>
                                </div>
                            )
                        )}
                        {filterTemplateData.length > 0 && (
                            <div className='wrapper-header'>
                                <div className='search-form-wrapper'>
                                    <div>
                                        <SearchIcon width='1.5rem' color='var(--color-main-white)'/>
                                    </div>
                                    <input type="text" placeholder='Search templates here' onChange={(e) => handleSearchChange(e)}/>
                                </div>
                                <button onClick={(e) => navigate('/early_warning/setup_template')}>+ Create New Template</button>
                            </div>
                        )}
                        <div className='body-2'>
                            {templateData.length > 0 ? (
                                filterTemplateData.map((item, key) => (
                                    <div key={key} className='template-card-wrapper' onClick={(e) => handleClickTemplate(item)}>
                                        <div className='icon-wrapper'>
                                            {dataMap.get(item.type)?.icon}
                                        </div>
                                        <div className='body-wrapper'>
                                            <span className='title' >{dataMap.get(item.type)?.name} Template - ({item.name})</span>
                                            <div className='details-wrapper'>
                                                <div className="cell header">Severity</div>
                                                <div className="cell" style={{width: '100%', height: `100%`, display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                                    <div style={{ width: '2rem', height: '0.5rem', backgroundColor: `${getSeverityColor(item.severity)}`, borderRadius: '0.2rem'}}></div>
                                                    <span style={{marginLeft: '1rem', fontSize: '0.8rem', textTransform: 'capitalize'}}>({item.severity})</span>
                                                </div>
                                                <div className="cell header">Name</div>
                                                <div className="cell">{item.warningName}</div>
                                                <div className="cell header">Description</div>
                                                <div className="cell">{item.description}</div>
                                            </div>
                                            <div className='edit-icon-wrapper'>
                                                <div className='template-ico edit-template-ico' onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleEditTemplateClick(item.id)
                                                }}>
                                                    <EditCardIcon width='1rem' color='var(--color-text)' />
                                                </div>
                                                <div className='template-ico delete-template-ico' onClick={(e) => {
                                                        e.stopPropagation()
                                                        showAlertDialog(
                                                            "Confirm Delete",
                                                            "Are you sure you want to delete this warning template?",
                                                            () => handleDeleteTemplateClick(item.id), undefined
                                                        )
                                                    }}>
                                                    <DeleteCardIcon width='1rem' color='var(--color-text)' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='empty-wrapper'> 
                                    <span>No any templates available</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {alertDialogState && (
                    <AlertDialog title={alertTitle} description={alertDescription} windowState={alertDialogState} setWindowState={setAlertDialogState} function={alertYesCallback} okFunction={alertOkCallback} />
                )}
                
                {/* {isLoading && (
                    <LoadingScreen />
                )} */}
                
                {isLoading && (
                    <div className='loading'>
                        <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} />
                    </div>
                )}
            </div>
           )}
        </>
        
    )
}

export default DashboardTemplate